





















import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import Enums from '@/lib/enums'
import appconst from '@/lib/appconst';
import { getLodop, demoDownloadPDF } from '@/common/js/LodopFuncs'
import QRcode from 'qrcodejs2'
import JsBarcode from 'jsbarcode' 
@Component
export default class WeightImgInput extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;

    created() {
        //this.setQrCode(this.$store.state.backmainlandorder.orderNumber);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
        } else {

            this.barcode(this.$store.state.backstockproduct.barcode);

        }
    }

    barcode(val: string) {
        JsBarcode("#barcode", val, {
            format: "CODE128",//选择要使用的条形码类型
            text: val,    //显示文本
            displayValue: true,//是否在条形码下方显示文字
            textPosition: "bottom",//设置文本的垂直位置
            fontOptions: "bold italic",//使文字加粗体或变斜体
            background: "#eee",//设置条形码的背景
            font: "fantasy",//设置文本的字体
            lineColor: "#2196f3",//设置条和文本的颜色。
            margin: 15//设置条形码周围的空白边距
        })
    }

      //打印大条码
 printBig() {
    var LODOP = getLodop();
    LODOP.PRINT_INITA(0, 0, "90mm", "40mm", "打印控件");
    LODOP.SET_PRINT_STYLE("FontSize", 9);
    LODOP.SET_PRINT_STYLE("Bold", 0);
     LODOP.ADD_PRINT_BARCODE("50mm", "30mm", "80mm", "30mm", "EAN128A", this.$store.state.backstockproduct.barcode);//条码
     LODOP.ADD_PRINT_TEXT("37mm", "3mm", "90mm", "1mm", "");
   // LODOP.PRINT();//打印
    LODOP.PREVIEW();//预览
    //LODOP.SET_PRINT_STYLEA(0, data.pList.length, data.pList.length);

}

}
